import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

function OrderFormOtherInfo(props) {
  return (
    <React.Fragment>

      <Grid item sm={12}>
        <Typography variant="overline">General Order Information</Typography>
        <div style={{ borderBottom: '1px dashed black' }}></div>
      </Grid>

      <Grid item sm={8}>
        <Typography variant="caption">Product Code: <b>{props.product_code}</b></Typography>
        <br />
        <Typography variant="caption">Product Name: <b>{props.product_name}</b></Typography>
      </Grid>
      <Grid item sm={4}>
        <Typography variant="caption">Customer Name: <b>{props.customer_name}</b></Typography>
        <br />
        <Typography variant="caption">Customer Email: <b>{props.customer_email}</b></Typography>
      </Grid>

    </React.Fragment>
  );
}

export default OrderFormOtherInfo;
